/** Shown on the dashboard penalty tile until compliance exposure is aggregated. */
export const PENALTY_EXPOSURE_PENDING_DISPLAY = "Calculation in progress...";
